import { isNumber } from './isType';
/**
 * Força um valor (normalmente uma string) para boolean.
 * Normalmente utilizado para converter valores recebidos de
 *
 * @Inputs dos componentes para boolean.
 *
 * @category Typing
 */
export const enforceBoolean = (value) => value != null && `${value}` !== 'false';
/**
 * recebe um valor 'unknown' e força que o retorno seja um número
 *
 * @category Typing
 */
export const enforceNumber = (value, defaultValue = 0) => isNumber(value) ? Number(value) : defaultValue;
